import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { UsuariosComponent } from "./usuarios.component";
import { UsuariosRoutingModule } from "./usuarios-routing.module";
import { UsuarioNavigationService } from "./shared/usuario-navigation.service";
import { UsuarioChangeComponent } from "./usuario-change/usuario-change.component";
import { UsuarioService } from "./shared/usuario.service";
import { UsuarioApiService } from "./shared/usuario-api.service";

@NgModule({
    imports: [
        SharedModule,
        UsuariosRoutingModule
    ],
    providers: [
        UsuarioNavigationService,
        UsuarioApiService,
        UsuarioService
    ],
    declarations: [
        UsuariosComponent,
        UsuarioChangeComponent
    ]

})
export class UsuariosModule {}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/usuarios/usuarios.module.ts
 **/